import { dataFetcher } from 'core/services/requestHandler';   

const getStudentFeedbacksByDate = async (data = {}, config = {}) => {
  return dataFetcher('feedback/getStudentFeedbacksByDate', data, {...config});
};

const getVendorFeedbacksByDate = async (data = {}, config = {}) => {
  return dataFetcher('feedback/getVendorFeedbacksByDate', data, {...config});
};

const deleteFeedback = async (data = {}, config = {}) => {
  return dataFetcher('feedback/deleteFeedback', data, {...config});
};

const getLibraryReviewsByDate = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getLibraryReviewsByDate', data, {...config});
};

const deleteLibraryReview = async (data = {}, config = {}) => {
  return dataFetcher('libraries/deleteLibraryReview', data, {...config});
};


export { getStudentFeedbacksByDate, getVendorFeedbacksByDate, deleteFeedback, getLibraryReviewsByDate, deleteLibraryReview };
